import isotope from 'isotope-layout';

(function($, undefined, isotope) {

    /*
     * HoverDir object.
     */
    $.HoverDir = function(options, element) {

        this.$el = $(element);

        this._init(options);

    };

    $.HoverDir.defaults = {
        hoverDelay: 0,
        reverse: false
    };

    $.HoverDir.prototype = {
        _init: function(options) {

            this.options = $.extend(true, {}, $.HoverDir.defaults, options);

            // load the events
            this._loadEvents();

        },
        _loadEvents: function() {

            var _self = this;

            this.$el.on('mouseenter.hoverdir, mouseleave.hoverdir', function(event) {

                var $el = $(this),
                    evType = event.type,
                    $hoverElem = $el.find('.back'),
                    direction = _self._getDir($el, {
                        x: event.pageX,
                        y: event.pageY
                    }),
                    cssPos = _self._getPosition(direction, $el);


                if (evType === 'mouseenter') {
                    $hoverElem.css({
                        "left": cssPos.from,
                        "top": cssPos.to
                    });

                    clearTimeout(_self.tmhover);

                    _self.tmhover = setTimeout(function() {

                        $hoverElem.show(0, function() {
                            $(this).css({
                                "top": 0,
                                "left": 0
                            }, 300);
                        });


                    }, _self.options.hoverDelay);

                } else {

                    $hoverElem.css({
                        "left": cssPos.from,
                        "top": cssPos.to
                    }, 300, function() {
                        $hoverElem.hide();
                    });

                    clearTimeout(_self.tmhover);

                }

            });

        },
        _getDir: function($el, coordinates) {

            /** the width and height of the current div **/
            var w = $el.width(),
                h = $el.height(),

                /** calculate the x and y to get an angle to the center of the div from that x and y. **/
                /** gets the x value relative to the center of the DIV and "normalize" it **/
                x = (coordinates.x - $el.offset().left - (w / 2)) * (w > h ? (h / w) : 1),
                y = (coordinates.y - $el.offset().top - (h / 2)) * (h > w ? (w / h) : 1),

                /** the angle and the direction from where the mouse came in/went out clockwise (TRBL=0123);**/
                /** first calculate the angle of the point,
                add 180 deg to get rid of the negative values
                divide by 90 to get the quadrant
                add 3 and do a modulo by 4  to shift the quadrants to a proper clockwise TRBL (top/right/bottom/left) **/
                direction = Math.round((((Math.atan2(y, x) * (180 / Math.PI)) + 180) / 90) + 3) % 4;

            return direction;

        },
        _getPosition: function(direction, $el) {

            var fromLeft, fromTop;

            switch (direction) {
                case 0:
                    // from top
                    if (!this.options.reverse) {
                        fromLeft = 0, fromTop = -$el.height();
                    } else {
                        fromLeft = 0, fromTop = -$el.height();
                    }

                    break;
                case 1:
                    // from right
                    if (!this.options.reverse) {
                        fromLeft = $el.width(), fromTop = 0;
                    } else {
                        fromLeft = -$el.width(), fromTop = 0;
                    }
                    break;
                case 2:
                    // from bottom
                    if (!this.options.reverse) {
                        fromLeft = 0, fromTop = $el.height();
                    } else {
                        fromLeft = 0, fromTop = -$el.height();
                    }
                    break;
                case 3:
                    // from left
                    if (!this.options.reverse) {
                        fromLeft = -$el.width(), fromTop = 0;
                    } else {
                        fromLeft = $el.width(), fromTop = 0;
                    }
                    break;
            }

            return {
                from: fromLeft,
                to: fromTop
            };

        }
    };

    var logError = function(message) {
        if (this.console) {
            console.error(message);
        }
    };

    $.fn.hoverdir = function(options) {

        if (typeof options === 'string') {

            var args = Array.prototype.slice.call(arguments, 1);

            this.each(function() {

                var instance = $.data(this, 'hoverdir');

                if (!instance) {
                    logError("cannot call methods on hoverdir prior to initialization; " +
                        "attempted to call method '" + options + "'");
                    return;
                }

                if (!$.isFunction(instance[options]) || options.charAt(0) === "_") {
                    logError("no such method '" + options + "' for hoverdir instance");
                    return;
                }

                instance[options].apply(instance, args);

            });

        } else {

            this.each(function() {

                var instance = $.data(this, 'hoverdir');
                if (!instance) {
                    $.data(this, 'hoverdir', new $.HoverDir(options, this));
                }
            });

        }

        return this;

    };

})(jQuery);

;( function( $ ) {

	$( function() {

		if ( $( '.nid-101-item-main-content' ).length ) {

            var $popup = $( '#nid-101-popup' ),
                $popupContent = $( '#nid-101-popup-conent' );

			$( '.open-popup-link' ).magnificPopup({
				type: 'inline',
				midClick: true,
				closeBtnInside: true,
				showCloseBtn: true,
				callbacks: {
					beforeOpen: function() {
                        $popup.addClass( 'loading' );
                        $popupContent.empty();
						this.st.mainClass = 'mfp-zoom-in';
					},
                    open: function() {
                        var id = +$( this.st.el ).data( 'id' ),
                            data = {
                                action: 'get_idea',
                                idea_id: id,
                                nid_fast_ajax: 1
                            };
						window.location.hash = id;

                        $.post( nordsjo.ajaxurl, data, function( result ) {
                            $popup.removeClass( 'loading' );
                            $popupContent.html( result.data );

                            if ( false === result.success ) {
                                setTimeout( function() {
                                    $.magnificPopup.close();
                                }, 2500 );
                            }
                        });
                    }
				}
			});


			if ( $( window ).width() > 600 ) {
				$( '.pl-img-holder' )
					.find( 'img' ).remove().end()
					.imageScroll({
						speed: 0.5,
						holderMaxHeight: 700,
						holderMinHeight: 700
					});
			}

            // Add Direction Aware Hover
            $( '.nid-101-item' ).each( function() {
                $( this ).hoverdir({
                    hoverDelay : 0
                });
            });
		}
	});


    $( window ).on('load', function() {
        var $filters = $( '#nid-101-filters-container' );
        if ( $filters.length ) {

            var $isotopeGrid = $( '#isotope-grid' ).isotope({
                itemSelector: '.nid-101-item',
                layoutMode: 'fitRows'
            });

            $filters.on( 'click', 'a', function( e ) {
                e.preventDefault();

                $( 'a', $filters ).removeClass( 'active' );

                $( this ).addClass( 'active' );
                var term = $( this ).data( 'term' );

                $isotopeGrid.isotope({ filter: '.' + term });
            });

            $( '.active', $filters ).trigger( 'click' );
        }

		var id = window.location.hash.replace('#','');
		$('a[data-id="'+id+'"]').click();
    });



}( jQuery, isotope ));
